import GaugeSettings from './Gauge';
export default GaugeSettings;